if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach((item) => {
        const remove = item.querySelector('.remove');
        if (remove) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');
          remove.addEventListener('click', (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');
        if (qty) {
          qty.addEventListener(
            'input',
            debounce((e) => {
              e.preventDefault();
              e.target.blur();

              // Get minimum quantity from data attribute or min attribute
              const minQuantity = parseInt(qty.dataset.minQuantity || qty.min || 1);
              const inputValue = parseInt(qty.value);

              // Validate minimum quantity
              if (inputValue < minQuantity) {
                qty.value = minQuantity;
              }

              this.updateCartQty(item, parseInt(qty.value));
            }, 500)
          );
          qty.addEventListener('click', (e) => {
            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add('processing');
      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }
      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty,
      });

      return fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            if (typeof response.description === 'string') {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch('?section_id=helper-cart');
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
          const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

          const cartItems = document.getElementById('AjaxCartForm');
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
            elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
            elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
          });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

          const event = new Event('cart-updated');
          this.dispatchEvent(event);
        })
        .catch((e) => {
          console.log(e);
          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove('processing');
        });
    }
  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
    }
    changeCartInput() {
      setTimeout(() => {
        document
          .getElementById('AjaxCartForm')
          .updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
      }, 50);
    }
  }

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

if (typeof FotosprintCartProductCopiesQuantity !== 'function') {
  class FotosprintCartProductCopiesQuantity extends HTMLElement {
    constructor() {
      super();
      this.cartItem = this.closest('.cart-form-item');
      this.baseQuantity = this.cartItem?.getAttribute('data-base-quantity');
      this.isFotolibro = this.cartItem?.getAttribute('data-is-fotolibro');
      if (this.isFotolibro) {
        const projectId = this.cartItem.dataset.projectId;
        this.extraSheetQuantity = this.cartItem.getAttribute('data-extra-sheets');
        this.extraSheetItem = Array.from(document.querySelectorAll('.cart-form-item')).filter(
          (item) => item.dataset.projectId === projectId && item.dataset.isFromFotolibro === '1'
        )[0];
      }
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
    }

    changeCartInput() {
      setTimeout(() => {
        const cartForm = document.getElementById('AjaxCartForm');
        const qty = parseInt(this.querySelector('#copies_quantity').value);

        cartForm.updateCartQty(this.cartItem, qty * this.baseQuantity).then(() => {
          if (this.isFotolibro && this.extraSheetItem) {
            cartForm.updateCartQty(this.extraSheetItem, qty * this.extraSheetQuantity);
          }
        });
      }, 50);
    }
  }

  if (typeof customElements.get('fotosprint-cart-product-copies-quantity') == 'undefined') {
    customElements.define('fotosprint-cart-product-copies-quantity', FotosprintCartProductCopiesQuantity);
  }
}

if (typeof FotosprintCartPrintCardQuantity !== 'function') {
  class FotosprintCartPrintCardQuantity extends HTMLElement {
    constructor() {
      super();
      this.cartItem = this.closest('.cart-form-item');
      this.projectId = this.cartItem?.getAttribute('data-project-id');
      this.baseQuantity = this.cartItem?.getAttribute('data-base-quantity');
      this.printCardCode = this.cartItem?.getAttribute('data-print-card-code');

      this.minusButton = this.querySelector('.qty-minus');
      this.plusButton = this.querySelector('.qty-plus');
      this.qtyInput = this.querySelector('#copies_quantity');
      this.qtyMin = this.qtyInput.getAttribute('min') ? parseInt(this.qtyInput.getAttribute('min')) : 1;
      this.qtyMax = this.qtyInput.getAttribute('max') ? parseInt(this.qtyInput.getAttribute('max')) : 999;

      this.isProcessing = false;

      this.updateButtonStates();

      this.minusButton.addEventListener('click', this.changeCartInput.bind(this));
      this.plusButton.addEventListener('click', this.changeCartInput.bind(this));
    }

    async changeCartInput(e) {
      try {
        e.preventDefault();
        e.stopPropagation();

        if (e.currentTarget.classList.contains('disabled')) {
          return;
        }

        const cartForm = document.getElementById('AjaxCartForm');
        const form = cartForm.querySelector('form');
        form.classList.add('processing');

        const isPlus = e.currentTarget.classList.contains('qty-plus');
        const isMinus = e.currentTarget.classList.contains('qty-minus');

        let newQuantity = parseInt(this.qtyInput.value);

        if (isPlus && newQuantity < this.qtyMax) {
          newQuantity++;
        } else if (isMinus && newQuantity > this.qtyMin) {
          newQuantity--;
        } else {
          form.classList.remove('processing');
          return;
        }

        this.qtyInput.value = newQuantity;

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const apiUrl = this.getApiUrl();

        const response = await fetch(`${apiUrl}/imaxel/printcard/update-quantity`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            projectId: this.projectId,
            cartId: cart.token,
            newQuantity,
            printCardCode: this.printCardCode,
            shop: Shopify.shop,
          }),
        });

        const result = await response.json();

        if (result.success) {
          window.refreshCart();
        } else {
          console.error('Error updating print card quantity:', result.error);
        }
      } catch (error) {
        console.error('Error updating print card quantity:', error);
      } finally {
        // Remover indicador de carga
        const cartForm = document.getElementById('AjaxCartForm');
        const form = cartForm?.querySelector('form');
        if (form) {
          form.classList.remove('processing');
        }
      }
    }

    updateButtonStates() {
      const currentQty = parseInt(this.qtyInput.value);

      if (currentQty <= this.qtyMin) {
        this.minusButton.classList.add('disabled');
      } else {
        this.minusButton.classList.remove('disabled');
      }

      if (currentQty >= this.qtyMax) {
        this.plusButton.classList.add('disabled');
      } else {
        this.plusButton.classList.remove('disabled');
      }
    }

    getApiUrl() {
      const apiUrlInput = document.getElementById('imaxel-api-url');

      return apiUrlInput?.value || '';
    }
  }

  if (typeof customElements.get('fotosprint-cart-printcard-quantity') == 'undefined') {
    customElements.define('fotosprint-cart-printcard-quantity', FotosprintCartPrintCardQuantity);
  }
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=helper-cart')
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        if (document.querySelector('[data-js-site-cart-sidebar]')) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        if (document.querySelector('cart-recommendations')) {
          document.querySelector('cart-recommendations').innerHTML = '';
          document.querySelector('cart-recommendations').generateRecommendations();
        }

        const event = new Event('cart-updated');
        cartItems.dispatchEvent(event);
      });
  };
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body,
            });
          }, 150)
        );
      }
    }
  );
}
